module.exports = __webpack_public_path__ + "static/media/line-blue.4e79da24.svg";